module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-04-food-05.edd068b6.jpg";